import React from 'react'
import {Nav, NavItem, NavLink,} from 'reactstrap'
import classnames from 'classnames'

import DashboardIcon from 'react-icons/lib/fa/dashboard'
import TrendsIcon from 'react-icons/lib/fa/line-chart'
import LogsIcon from 'react-icons/lib/fa/book'
import AboutIcon from 'react-icons/lib/fa/info-circle'
import SettingsIcon from 'react-icons/lib/fa/sliders'
import SubscriptionIcon from 'react-icons/lib/fa/bell'

let ControllerNavigationTabs = ({activeTab, user, archived,is_subscription_paid,currentdate,subsEndDate, controllerTeam, seasonPlan,onTabClick, is_trial, subsRemainingDays}) =>
    <Nav tabs>
        {user.canViewControllersForTeam(controllerTeam) ?
        <NavItem>
            <NavLink
                title="Dashboard"
                className={classnames({ active: activeTab === '1' }) + " pl-1 pr-1 pb-2 pl-sm-2 pr-sm-2 pl-md-3 pr-md-3"}
                onClick={() => onTabClick('1')}>
                <h2 className="d-block d-sm-none mr-2 ml-2 mb-0">
                    <DashboardIcon/>
                </h2>
                <span className="d-none d-sm-inline-block mr-sm-2 ml-sm-0">
                    <DashboardIcon/>
                </span>

                <span className="d-none d-sm-inline-block d-md-none">
                    Dash
                </span>
                <span className="d-none d-md-inline-block">
                    Dashboard
                </span>
            </NavLink>
        </NavItem>:
            null}
        {is_trial && subsRemainingDays === 0? null:is_subscription_paid && currentdate >subsEndDate ?null:
        user.canSendCommandsForTeam(controllerTeam) && !archived ?
         
            <NavItem>
                <NavLink
                    title="Settings"
                    className={classnames({ active: activeTab === '2' }) + " pl-1 pr-1 pb-2 pl-sm-2 pr-sm-2 pl-md-3 pr-md-3"}
                    onClick={() => onTabClick('2')}>
                    <h2 className="d-block d-sm-none mr-2 ml-2 mb-0">
                        <SettingsIcon/>
                    </h2>
                    <span className="d-none d-sm-inline-block mr-sm-2 ml-sm-0">
                        <SettingsIcon/>
                    </span>

                    <span className="d-none d-sm-inline-block d-md-none">
                        Setting
                    </span>
                    <span className="d-none d-md-inline-block">
                        Settings
                    </span>
                </NavLink>
            </NavItem>:
            null}
        {user.canViewDataForTeam(controllerTeam) ?
            <NavItem>
                <NavLink
                    title="Trends"
                    className={classnames({ active: activeTab === '3' }) + " pl-1 pr-1 pb-2 pl-sm-2 pr-sm-2 pl-md-3 pr-md-3"}
                    onClick={() => onTabClick('3')}>
                    <h2 className="d-block d-sm-none mr-2 ml-2 mb-0">
                        <TrendsIcon/>
                    </h2>
                    <span className="d-none d-sm-inline-block mr-sm-2 ml-sm-0">
                        <TrendsIcon/>
                    </span>

                    <span className="d-none d-sm-inline-block d-md-none">
                        Trend
                    </span>
                    <span className="d-none d-md-inline-block">
                        Trends
                    </span>
                </NavLink>
            </NavItem>:
            null}
        {user.canViewDataForTeam(controllerTeam) ?
            <NavItem>
                <NavLink
                    title="Logs"
                    className={classnames({ active: activeTab === '4' }) + " pl-1 pr-1 pb-2 pl-sm-2 pr-sm-2 pl-md-3 pr-md-3"}
                    onClick={() => onTabClick('4')}>
                    <h2 className="d-block d-sm-none mr-2 ml-2 mb-0">
                        <LogsIcon/>
                    </h2>
                    <span className="d-none d-sm-inline-block mr-sm-2 ml-sm-0">
                        <LogsIcon/>
                    </span>

                    <span className="d-none d-sm-inline-block d-md-none">
                        Log
                    </span>
                    <span className="d-none d-md-inline-block">
                        Logs
                    </span>
                </NavLink>
            </NavItem>:
            null}
        {user.canViewControllersForTeam(controllerTeam) ?
            <NavItem>
                <NavLink
                    title="About"
                    className={classnames({ active: activeTab === '5' }) + " pl-1 pr-1 pb-2 pl-sm-2 pr-sm-2 pl-md-3 pr-md-3"}
                    onClick={() => onTabClick('5')}>
                    <h2 className="d-block d-sm-none mr-2 ml-2 mb-0">
                        <AboutIcon/>
                    </h2>
                    <span className="d-none d-sm-inline-block mr-sm-2 ml-sm-0">
                        <AboutIcon/>
                    </span>

                    <span className="d-none d-sm-inline-block">
                        About
                    </span>
                </NavLink>
            </NavItem>:
            null}
        {user.canViewControllersForTeam(controllerTeam) ?
            <NavItem>
                <NavLink
                    title="Subscription"
                    className={classnames({ active: activeTab === '6' }) + " pl-1 pr-1 pb-2 pl-sm-2 pr-sm-2 pl-md-3 pr-md-3"}
                    onClick={() => onTabClick('6')}>
                    <h2 className="d-block d-sm-none mr-2 ml-2 mb-0">
                        <SubscriptionIcon/>
                    </h2>
                    <span className="d-none d-sm-inline-block mr-sm-2 ml-sm-0">
                        <SubscriptionIcon/>
                    </span>

                    <span className="d-none d-sm-inline-block d-md-none">
                        Sub
                    </span>
                    <span className="d-none d-md-inline-block">
                        Subscription
                    </span>
                </NavLink>
            </NavItem>:
            null}
    </Nav>

export default ControllerNavigationTabs



// WEBPACK FOOTER //
// ./src/components/ui/ControllerNavigationTabs.js